<button
  type="button"
  class="theme-switcher theme-switcher--row"
  role="switch"
  [class.theme-switcher--active]="isDarkTheme()"
  [attr.aria-checked]="isDarkTheme()"
  [attr.aria-label]="((isDarkTheme() ? 'theme.switchToLight' : 'theme.switchToDark') | translate)"
  [title]="((isDarkTheme() ? 'theme.darkMode' : 'theme.lightMode') | translate)"
  (click)="toggleTheme()"
>
  <span class="material-symbols-outlined theme-switcher__icon" aria-hidden="true">
    {{ isDarkTheme() ? 'light_mode' : 'dark_mode' }}
  </span>
  <span class="theme-switcher__label">{{ 'theme.nightMode' | translate }}</span>
  <span class="theme-switcher__switch" aria-hidden="true">
    <span class="theme-switcher__thumb"></span>
  </span>
</button>
